import React, { useContext, useEffect, useState, useRef } from 'react';
import { BoxWrapper } from '../../../style';
import arrowIcon from "../../../images/arrow.png";
import PanInput from '../../../components/OtpInput/PanInput';
import { FormWrapper } from '../../../components/loan/style';
import Button from '../../../components/ui/Button';
import Alert from '../../../components/ui/Alert';
import { verifyPan } from '../../../Utils/api'; // Import getDashboard
import { useNavigate } from 'react-router-dom';
import Input from '../../../components/ui/Input';
import { getStorage, goBack, setStorage, isEmpty } from '../../../Utils/common';
import { regexPan } from '../../../Utils/formValidation';
import ContextDashboard from '../../../Context/ContextDashboard';
import ProgressBar from "../../../components/ProgressBar/ProgressBar";

const initialData = {
  monthlyIncome: "",
};

function PanDetails() {
  const [pan, setPan] = useState(["", "", "", "", "", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState({});
  const [showSteps, setShowSteps] = useState(-1);
  const [toggle, setToggle] = useState(true);
  const [progressBar, setProgressBar] = useState(getStorage("step_percent"));
  const { setps } = useContext(ContextDashboard);
  const inputRefs = useRef([]);
  const [formData, setFormData] = useState(initialData);
  const [formDataError, setFormDataError] = useState(initialData);

  const navigate = useNavigate();
  const { message, setMessage, logout, handleEvent } = useContext(ContextDashboard);

  const submit = () => {
    let panData = pan?.join("").toUpperCase();

    // Check if PAN number is valid
    if (!regexPan.test(panData)) {
      setMessage({ type: 'error', msg: "Please enter a valid PAN number" });
      return;
    }

    // Validate monthly income field
    if (!formData.monthlyIncome) {
      setFormDataError({ ...formDataError, monthlyIncome: "Monthly income is required" });
      return;
    }

    const param = {
      event_name: "pancard_verification",
      pancard: panData,
      profile_id: getStorage("cust_profile_id") || "",
      monthly_income: formData.monthlyIncome,
    };

    setLoading(true);
    verifyPan(param).then(resp => {
      setLoading(false);
      if (resp?.data?.Status === 1) {
        setStorage("pancard", panData);
        setStorage("fullName", resp?.data?.Data?.full_name);
        setStorage("step_percent", resp?.data?.Data?.step_percentage);
        setStorage("next_step", resp?.data?.Data?.next_step);
        
        // Store PAN verification data for personal info form
        if (resp?.data?.Data?.father_name) {
          setStorage("pan_father_name", resp?.data?.Data?.father_name);
        }
        if (resp?.data?.Data?.dob) {
          // Convert date format from backend to D/M/Y format for display
          const dob = resp?.data?.Data?.dob;
          let formattedDob = dob;
          
          console.log("Original DOB from backend:", dob);
          
          // Handle different possible date formats from backend
          if (dob && dob.includes('-')) {
            // Handle YYYY-MM-DD format from MySQL (most common)
            const parts = dob.split('-');
            console.log("Date parts from YYYY-MM-DD:", parts);
            
            if (parts.length === 3) {
              const year = parts[0];
              const month = parts[1];
              const day = parts[2];
              formattedDob = `${day}/${month}/${year}`;
              console.log("Converted YYYY-MM-DD to D/M/Y:", formattedDob);
            }
          } else if (dob && dob.includes('/')) {
            const parts = dob.split('/');
            console.log("Date parts from slash format:", parts);
            
            if (parts.length === 3) {
              const firstPart = parseInt(parts[0]);
              const secondPart = parseInt(parts[1]);
              const year = parts[2];
              
              // Check if it's M/D/Y format (first part 1-12, second part 1-31)
              if (firstPart >= 1 && firstPart <= 12 && secondPart >= 1 && secondPart <= 31) {
                // Convert M/D/Y to D/M/Y
                formattedDob = `${secondPart}/${firstPart}/${year}`;
                console.log("Converted M/D/Y to D/M/Y:", formattedDob);
              } else if (firstPart >= 1 && firstPart <= 31 && secondPart >= 1 && secondPart <= 12) {
                // Already D/M/Y format
                formattedDob = dob;
                console.log("Already D/M/Y format:", formattedDob);
              } else {
                // Try to detect by checking which part could be month
                if (firstPart > 12 && secondPart <= 12) {
                  // First part is day, second is month - already D/M/Y
                  formattedDob = dob;
                  console.log("Detected D/M/Y format:", formattedDob);
                } else if (firstPart <= 12 && secondPart > 12) {
                  // First part is month, second is day - convert M/D/Y to D/M/Y
                  formattedDob = `${secondPart}/${firstPart}/${year}`;
                  console.log("Converted M/D/Y to D/M/Y (detected):", formattedDob);
                }
              }
            }
          }
          
          setStorage("pan_dob", formattedDob);
          console.log("Final stored DOB:", formattedDob);
        }
        
        setResponse(resp?.data);
        setMessage({ type: 'success', msg: resp?.data?.Message, place: "globle" });
        handleEvent(getStorage('next_step'));
      } else if (resp?.data?.Status === 4) {
        logout();
      } else {
        setPan(["", "", "", "", "", "", "", "", "", ""]);
        if (inputRefs.current[0]) {
          inputRefs.current[0].focus();
        }
        setMessage({ type: 'error', msg: resp?.data?.Message });
      }
    });
  };

  const showSteps_ = () => {
    setToggle(!toggle);
  };

  useEffect(() => {
    if (!isEmpty(setps)) {
      checkStep(setps);
    }
  }, [setps]);

  function checkStep(data) {
    setProgressBar(data?.step_complete_percent);
    const steps = data?.step_stage - 1;
    if (data?.step_complete_percent === 100) {
      setToggle(false);
    }
    setShowSteps(steps);
  }

  const onChange = (e) => {
    let { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormDataError({ ...formDataError, [name]: "" });
  };

  // Restrict user input to 10 digits in the "Monthly Income" field
  const handleIncomeChange = (e) => {
    const { value } = e.target;

    // Allow only numbers and restrict input to a maximum of 10 digits
    if (/^\d{0,7}$/.test(value)) {
      setFormData({ ...formData, monthlyIncome: value });
      setFormDataError({ ...formDataError, monthlyIncome: "" });
    }
  };

  return (
    <>
      <ProgressBar value={`${progressBar}%`}>
        <div></div>
        <></>
      </ProgressBar><br />
      <BoxWrapper className="w100">
        <div className="formmainBox flex">
          <div className="left">
            <div className='center gap4 pointer' onClick={() => goBack(navigate, "/my-dashboard/")}>
              <img src={arrowIcon} alt="" /> <span>Back</span>
            </div>
          </div>
          <div className="right">
            <h2>PAN Authentication <span style={{color:'red'}}>*</span></h2>
            <p>Please enter your PAN Card number. Your identity is secure with us.</p>

            <FormWrapper>
              <Alert setMessage={setMessage} message={message} />
              <div className="inputBox panBox">
                <PanInput
                  type="text"
                  setOtp={setPan}
                  otp={pan}
                  isDisable={false}
                  placeholder="*"
                  number={false}
                  inputRefs={inputRefs}
                /><br/><br/>

                <Input
                  label="Monthly Income *"
                  name="monthlyIncome"
                  error={formDataError?.monthlyIncome}
                  onChange={handleIncomeChange}  // Use the new handler for restricting input
                  value={formData?.monthlyIncome}
                  required={true}
                  type="number"
                />
              </div>

              <div className="button">
                <Button title="Continue" onClick={submit} loading={loading} />
              </div>
            </FormWrapper>
          </div>
        </div>
      </BoxWrapper>
    </>
  );
}

export default PanDetails;
